import { Component, OnInit } from '@angular/core';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-main',
  templateUrl: './home-main.component.html',
  styleUrls: ['./home-main.component.css']
})
export class HomeMainComponent implements OnInit {

  seoData: SeoSocialShareData = {
    title:  'Neprose - Home',
    description: 'Your next real estate investment opportunity could be right around the corner.',
    image: environment.url+'/assets/logo.png'
  };

  constructor(private readonly seoSocialShareService: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seoSocialShareService.setData(this.seoData)
  }

}
